module.exports = __webpack_public_path__ + "img/arrowup.9218cb2f.svg";